"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.insertComment = void 0;
const utils_1 = require("../../utils");
const types_1 = require("../../types");
const store_1 = require("../../exports/store");
const command_manager_1 = require("../../command_manager");
const model_1 = require("../../model");
exports.insertComment = {
    undoable: false,
    execute(context, options) {
        const { model: state } = context;
        const { datasheetId, recordId, comments } = options;
        const snapshot = store_1.Selectors.getSnapshot(state, datasheetId);
        if (!snapshot) {
            return null;
        }
        const recordMap = snapshot.recordMap;
        if (!recordMap[recordId]) {
            return null;
        }
        const actions = [];
        const recordComments = recordMap[recordId].comments;
        const commentIds = recordComments ? recordComments.map(item => item.commentId) : [];
        const action = comments.reduce((collection, comment) => {
            const commentId = (0, utils_1.getNewIds)(utils_1.IDPrefix.Comment, 1, commentIds)[0];
            commentIds.push(commentId);
            const insertAction = model_1.DatasheetActions.insertComment2Action(state, {
                datasheetId,
                recordId,
                insertComments: [Object.assign(Object.assign({}, comment), { commentId: commentId })],
            });
            if (!insertAction) {
                return collection;
            }
            collection.push(...insertAction);
            return collection;
        }, []);
        if (!action) {
            return null;
        }
        actions.push(...action);
        if (!actions.length) {
            return null;
        }
        return {
            result: command_manager_1.ExecuteResult.Success,
            resourceId: datasheetId,
            resourceType: types_1.ResourceType.Datasheet,
            actions,
            datasheetId,
        };
    },
};
//# sourceMappingURL=insert_comment.js.map